// import * as Sentry from "@sentry/react";
// import React from "react";
import ReactDOM from "react-dom/client";
// import TagManager from "react-gtm-module";
import { Provider } from "react-redux";

import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./css/player-cards.css";
import "./css/webapp-formations.css";
import "./index.css";
import store from "./redux/store";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // <React.StrictMode>
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>,
  // </React.StrictMode>,
);
